import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'wrapRight'
})
export class WrapRightPipe implements PipeTransform {
    transform(value: any, wrapper: string = "<em>_</em>", length = 8) {
        if (value == null) return value;
        if (value.length <= length) {
            return wrapper.replace('_', value);
        } else {
            return value.substr(0, value.length - length) +
                wrapper.replace('_', value.substr(value.length - length));
        }
    }
}